import { Type } from 'class-transformer';
import dayjs from 'dayjs';
import { Model } from './model';
import { Bank } from './bank';
import { LinkedIntegration } from './linked_integration';
import { TransformStringToDayJS } from './utils';

export enum BankAccountType {
  CASH_MANAGEMENT = 'cash_management',

  CHECKING = 'checking',

  SAVINGS = 'savings',

  CD = 'cd',

  MONEY_MARKET = 'money_market',

  PAYPAL = 'paypal',

  OTHER = 'other',
}

export const bankAccountTypes = [
  {
    label: 'Checking',
    value: BankAccountType.CHECKING,
  },
  {
    label: 'Savings',
    value: BankAccountType.SAVINGS,
  },
  {
    label: 'Money Market',
    value: BankAccountType.MONEY_MARKET,
  },
  {
    label: 'Cash Management',
    value: BankAccountType.CASH_MANAGEMENT,
  },
  {
    label: 'Certificate of Deposit (CD)',
    value: BankAccountType.CD,
  },
  {
    label: 'Other',
    value: BankAccountType.OTHER,
  },
];

export class BankAccount extends Model {
  id: string;

  archived: boolean;

  @Type(() => Bank)
  bank: Bank | null;

  currency: string;

  erp_account_number: string | null;

  mask: string;

  nickname: string | null;

  name: string;

  @TransformStringToDayJS()
  last_synced_at: dayjs.Dayjs | null;

  @TransformStringToDayJS()
  last_transaction_sync_at: dayjs.Dayjs | null;

  ledger_account_id: string | null;

  erp_account_id: string | null;

  linked_integration_id: string | null;

  @Type(() => LinkedIntegration)
  linked_integration: LinkedIntegration | null;

  official_name: string | null;

  party_name: string | null;

  remote_id: string | null;

  routing_number: string | null;

  timezone: string | null;

  type: BankAccountType;

  get typeName(): string {
    const typeObj = bankAccountTypes.find((t) => t.value === this.type);
    return typeObj ? typeObj.label : this.type;
  }
}
